class FileModel {

    constructor($parse) {

      return {
          restrict: 'A',
          link: ($scope, $el, $attr) => {
              let model = $parse($attr.fileModel);
              let modelSetter = model.assign;

              $el.bind('change', function(){
                  $scope.$apply(function(){
                      modelSetter($scope, $el[0].files[0]);
                  });
              });
          }
      };

    }

}

angular.module('cpm')
  .directive('fileModel', ['$parse', ($parse) => {
      'use strict';
      return new FileModel($parse);
  }]);
